import axios from "axios";

const getBaseUrl = () => {
  const { hostname, port } = window.location;

  if (
    port === "3001" ||
    port === "3002" ||
    hostname === "admin.unitersacademy.com" ||
    hostname === "admin-dev.unitersacademy.com"
  ) {
    return "admin/account/login";
  } else if (
    port === "3000" ||
    hostname === "partner.unitersacademy.com" ||
    hostname === "partner-dev.unitersacademy.com"
  ) {
    return "client/account/login";
  } else {
    throw new Error("Unsupported port or domain");
  }
};

const loginUrl = getBaseUrl();

export function postLoginData(userData) {
  return axios.post(loginUrl, {
    ...userData,
  });
}

const forgetPasswordUrl = "forget/password";

export function postForgetPassword(userData) {
  return axios.post(`${forgetPasswordUrl}/send-link`, {
    ...userData,
  });
}

export function postValidateResetPasswordToken(userData) {
  return axios.post(`${forgetPasswordUrl}/validate-token`, {
    ...userData,
  });
}

export function postResetPassword(userData) {
  return axios.post(`${forgetPasswordUrl}/change`, {
    ...userData,
  });
}

export function logout() {
  return axios.get(`logout`);
}
